// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s0-6";
export var imgContainer = "_s0-3";
export var menuIcon = "_s0-5";
export var pillWrapper = "_s0-2";
export var pillsContainer = "_s0-1";
export var subscriptionCard = "_s0-0";
export var subscriptionLogo = "_s0-4";